import React from 'react';
import { useInViewAnimation } from '../hooks/useInViewAnimation';

// The question the site never answered: what actually happens if I hire him?
// Three steps, in order — the numbering encodes a real sequence, not decoration.

const STEPS = [
  {
    title: 'Week one: scope',
    body:
      "We find the shortest path to something real. I map what already exists, cut what doesn't earn its keep, and we agree on what ships first and how we'll know it worked.",
  },
  {
    title: 'Weeks two to six: build',
    body:
      'I build it: the product, the engineering, and the go to market work around it. You get working software on a weekly cadence, not status decks, and async access whenever you need it.',
  },
  {
    title: 'Ongoing: run it',
    body:
      'Shipping is the start. I stay on for the part most builds skip: instrumentation, first customers, pricing, and the iteration that turns a launch into revenue.',
  },
];

export const HowIWorkSection = () => {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section
      ref={ref}
      id="how-i-work"
      className="max-w-[1200px] mx-auto px-6 py-20 scroll-mt-24"
      data-testid="how-i-work-section"
    >
      <div className="mb-12">
        <p
          className={`font-mono text-xs uppercase tracking-[0.2em] text-[#273C46]/70 mb-3 ${
            isInView ? 'animate-fade-in-up' : 'opacity-0'
          }`}
        >
          The engagement
        </p>
        <h2
          className={`text-3xl md:text-4xl text-[#051A24] ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          style={{ animationDelay: '0.1s' }}
        >
          How I{' '}
          <span style={{ fontFamily: "'Playfair Display', serif" }} className="italic">
            work
          </span>
        </h2>
      </div>

      <ol className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="how-i-work-steps">
        {STEPS.map((step, index) => (
          <li
            key={step.title}
            className={`bg-white border border-[#E0EBF0] rounded-2xl p-8 flex flex-col ${
              isInView ? 'animate-fade-in-up' : 'opacity-0'
            }`}
            style={{ animationDelay: `${0.2 + index * 0.1}s` }}
          >
            <span className="font-mono text-xs text-[#273C46]/70 tracking-[0.2em] mb-4">
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="text-xl font-medium text-[#051A24] mb-3">{step.title}</h3>
            <p className="text-sm text-[#273C46] leading-relaxed">{step.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default HowIWorkSection;
